import NextLink from 'next/link';
import { NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import { useI18n } from 'next-localization';
import styles from './ArticleCard.module.scss';
import { ArticleSeriesType } from 'model/Article';

type Props = {
  className: string;
  fields: ArticleSeriesType;
  count: number;
};

const ArticleSeriesCard = ({ fields, className, count }: Props) => {
  const { t } = useI18n();

  const getCountText = t('articlesAvailable').replace('{token.articlesCount}', `${count}`);

  return (
    <div className={`${className} d-flex ${styles['article-card__wrapper']}`}>
      <NextLink href={fields.url} className="d-flex w-100 text-decoration-none">
        <div className={`${styles['article-series-card']} d-flex flex-column w-100`}>
          <div className={`${styles['article-series-card__thumbnail']} flex-shrink-0`}>
            <NextImage
              field={{ src: fields.image.url }}
              alt={fields.image?.alt || ''}
              width={370}
              height={270}
              className="w-100 h-auto object-fit-cover"
            />
          </div>
          <div className="d-flex flex-column p-3 flex-grow-1 vectorBasedBackground">
            <h4 className={`${styles['article-series-card__title']} mb-3`}>{fields.name}</h4>
            <div className="mt-auto">
              <p className="field-text mb-0">{getCountText}</p>
            </div>
          </div>
        </div>
      </NextLink>
    </div>
  );
};

export default ArticleSeriesCard;
